/**
 * Step 6: Nacionalidade
 * Coleta informações sobre a nacionalidade do usuário
 */

import React, { useState } from 'react';
import { StepContainer, ChoiceButtons, StepNavigation } from '../components';
import { StepProps, useFormContext } from '../context';
import { useFormValidation } from '../hooks';

const Step6_Nacionalidade: React.FC<StepProps> = ({ onNext, onPrevious, data, isLoading }) => {
  const { updateFields } = useFormContext();
  const [localData, setLocalData] = useState({ nationality: data.nationality || '' });
  const [errors, setErrors] = useState<Record<string, string>>({});

  const options = [
    { label: 'Brasileira', value: 'Brasileira' },
    { label: 'Venezuelana ', value: 'Venezuelana' },
    { label: 'Argentina', value: 'Argentina' },
    { label: 'Paraguaia', value: 'Paraguaia' },
    { label: 'Outra', value: 'Outra' },
  ];

  const handleSelectOption = (value: string) => {
    setLocalData({ nationality: value });
    setErrors({});
  };

  const handleNext = () => {
    if (!localData.nationality) {
      setErrors({ nationality: 'Selecione uma nacionalidade' });
      return;
    }

    updateFields(localData);
    onNext(localData);
  };

  return (
    <StepContainer
      title="Qual sua nacionalidade?"
      description="Precisamos saber sua nacionalidade"
    >
      <div>
        <ChoiceButtons
          options={options}
          selected={localData.nationality}
          onSelect={handleSelectOption}
        />
        {errors.nationality && (
          <p className="text-red-600 text-sm mt-2">{errors.nationality}</p>
        )}
      </div>

      <StepNavigation
        onNext={handleNext}
        onPrevious={onPrevious}
        isLoading={isLoading}
        showPrevious={true}
      />
    </StepContainer>
  );
};

export default Step6_Nacionalidade;
